export default "__VITE_ASSET__BeidTldx__"